import React, { useContext, useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import { View, Text, Pressable } from 'react-native';
import {
  ASSET,
  UPDATE_ASSET_RELEASE_SENT,
  UPDATE_SELLER_ASSET_TO_READY,
  DESTROY_ASSET,
  REMOVE_ASSET,
  CONNECT_TO_SOARR,
} from './queries';
import { useParams } from 'react-router-dom';
import { AssetsShowContainer, Label } from './elements';
import SubNav from './SubNav';
import {
  ContentContainer,
  LinkContainer,
  MainContainer,
  TableContainer,
  PageTitle,
  TabButtonContainer,
  AssetTabButton,
  TabText
} from '../../elements';
import styled from 'styled-components/native';
import webStyled from 'styled-components';
import { elGray, elLightLightGray, elRed } from '../../styles/colors';
import formatAssetName from '../../utils/formatAssetName';
import Modal from 'app/src/elements/Modal';
import AddAssetToSale from './AddAssetToSale';
import Fees from '../Fees';
import Expenses from './Expenses';
import NewTitleLog from 'app/src/components/TitleLogs/new';
import EditTitleLog from 'app/src/components/TitleLogs/edit';
import DataTable from '@preflighttech/preflight-tables';
import { Link, useNavigate } from 'app/src/utils/routing';
import Correspondence from '../Correspondence';
import TitleLogs from '../TitleLogs';
import formattedLocation from './formattedLocation';
import { formattedConsignmentLocation } from './formattedLocation';
import moment from 'moment';
import AssignToUsers from './AssignToUsers';
import TitleLogHistory from '../TitleLogs/TitleLogHistory';
import EditNotes from './EditNotes';

import AuthContext from 'app/src/contexts/AuthContext';
import UserContext from 'app/src/contexts/UserContext';
import ResourceNotifications from 'app/src/components/Notifications/Resource';
import { currency } from 'app/src/components/Sales/Process/currency';
import { numberWithDelimiter } from 'app/src/utils/stringHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import Invoices from '../Accounting/Invoices';

import SaleDetail from './SaleDetail';
import SaleHistory from './SaleHistory';

// flex: 1 sized this bar from leftover space, so multi-line content overflowed.
const AssetSubNav = styled(View)`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  background-color: ${elLightLightGray};
  padding-left: 50px;
  padding-top: 15px;
  padding-bottom: 15px;
  align-items: center;
  border-bottom-color: black;
  border-bottom-width: 1px;
`;

const UpperRow = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

const LowerRow = styled(View)`
  flex-direction: row;
  margin-top: auto;
`;

const LinkSpace = styled(View)`
  width: 3%;
`;

const NotesContainer = styled(View)`
  background-color: ${elGray};
  display: flex;
  flex: 1;
  border-radius: 5px;
  padding: 10px;
`;

const SellerNotesContainer = styled(View)`
  background-color: ${elGray};
  display: flex;
  flex-direction: row;
  flex: 1;
  border-radius: 5px;
  padding: 10px;
`;

const Column = styled(View)`
`;

const Field = styled(View)`
  flex-direction: row;
`;

const Value = styled(Text)`
  margin-right: 10px;
`;

const Photo = webStyled.img`
  height: 100%;
`;

const EndLinksContainer = styled(View)`
  flex: 1;
  min-width: 40px;
  justify-content: flex-end;
  flex-direction: row;
  margin-right: 20px;
`;

const TitleLogContainer = styled(View)`
  flex: 1;
  margin-right: 10px;
  align-items: flex-end;
`;

const ReleaseContainer = styled(View)`
  margin-right: 30px;
  align-items: flex-end;
`;

const TitleLogLinks = styled(View)`
  flex-direction: row;
`;

const TitleLogStatus = styled(View)`
  display: flex;
  flex-direction: row;
  margin-right: 20px;
`;

const DESTROY_CONFIRM =
  'This asset can be removed because it is not and has not been in a sale ' +
  'has no manual fees or expenses added. Really remove this asset?';

const REMOVE_CONFIRM =
  "Remove this asset from inventory? Its history will be retained and it can " +
  "be accessed from the seller's Removed Assets list";

const Asset = props => {
  const { sellerId, assetId } = useParams();
  const [showAddAssettoSaleModal, setShowAddAssettoSaleModal] = useState(false);
  const [showAddUsersToAssetModal, setShowAddUsersToAssetModal] = useState(false);
  const [showAddTitleLogModal, setShowAddTitleLogModal] = useState(false);
  const [showEditTitleLogModal, setShowEditTitleLogModal] = useState(false);
  const [showTitleLogHistory, setShowTitleLogHistory] = useState(false);
  const [showEditNotesModal, setShowEditNotesModal] = useState(false);
  const [clickedTitleLog, setClickedTitleLog] = useState(false);
  const [editNotes, setEditNotes] = useState(false);
  const [asset, setAsset] = useState();
  const [activeTab, setActiveTab] = useState('Fees')
  const { hasPolicy } = useContext(AuthContext);
  const { screenWidth } = useContext(UserContext)
  const navigate = useNavigate();

  const { loading, error, data, refetch } = useQuery(
    ASSET, { variables: { id: assetId } }
  );
  const [updateReleaseSent] = useMutation(UPDATE_ASSET_RELEASE_SENT, {
    onCompleted: () => {
      refetch();
    }
  });

  const [updateAsset] = useMutation(UPDATE_SELLER_ASSET_TO_READY, {
    onCompleted: () => {
      refetch();
    }
  });

  const [destroyAsset] = useMutation(DESTROY_ASSET, {
    onCompleted: () => navigate(`/sellers/${sellerId}`)
  });

  const [removeAsset] = useMutation(REMOVE_ASSET, {
    onCompleted: () => navigate(`/sellers/${sellerId}`)
  });

  const [connectToSoarr] = useMutation(CONNECT_TO_SOARR, {
    onCompleted: () => window.location.reload()
  });

  const confirmDestroy = () => {
    if (window.confirm(DESTROY_CONFIRM)) {
      destroyAsset({ variables: { id: assetId } });
    }
  };

  const confirmRemove = () => {
    if (window.confirm(REMOVE_CONFIRM)) {
      removeAsset({ variables: { id: assetId, remove: true } });
    }
  };

  const confirmReadd = () => {
    if (window.confirm('Add back to inventory?')) {
      removeAsset({ variables: { id: assetId, remove: false } });
    }
  };

  useEffect(() => {
    setAsset(data?.asset)
  }, [data])

  if(loading || !data || !asset) {
    return <DataState.Loading />;
  }

  let feeResource = asset;
  let sellFeePrefix = asset.feeType;
  let sellFee = 'No Fee Setup';

  if ('Seller' === asset.feeType) {
    feeResource = asset.seller;
    sellFeePrefix = 'Seller Default';
  }

  if (feeResource.feeAmount > 0) {
    if ('Percent' === feeResource.feeType) {
      sellFee = `${sellFeePrefix} - ${feeResource.feeAmount}%`;
    } else {
      sellFee = `${sellFeePrefix} - ${currency(feeResource.feeAmount)}`;
    }
  }

  const photoUrl = asset?.photos[0]?.url || asset?.soarrPhotoUrls[0];

  return (
    <View>
      <SubNav
        sellerId={asset?.seller?.id}
        sellerName={asset?.seller?.name}
        assetId={assetId}
        asset={asset}
      />
      <AssetSubNav>
        <LinkContainer s>
          {asset &&
            <View style={{
              width: asset.status === 'Not Yet Ready' ? '30%' : '15%',
              flexWrap: 'nowrap',
              display: 'flex',
              flexDirection: 'row'
            }}>
              <Text><b>{formatAssetName(asset)}</b></Text>
              <Text style={{color: elRed}}>
                <b>{
                  asset.status === 'Not Yet Ready' ?
                    <Pressable
                      onPress={() => {
                        if(window.confirm('Mark Ready for Sale?')) {
                          updateAsset({variables: {id: assetId, status: 'Ready'}})
                        }
                      }}
                    >
                      {` - Seller Added - ${asset.status} (Click to Mark Ready)`}
                    </Pressable> :
                    ''
                }</b>
              </Text>
              <LinkSpace/>
            </View>
          }
          <SaleDetail asset={asset} setShowModal={setShowAddAssettoSaleModal}
            screenWidth={screenWidth}
          />
          <LinkSpace />
          <Pressable
            onPress={() => { setShowAddUsersToAssetModal(true)}}
          >
            <Text>+ Add Users</Text>
          </Pressable>

          {hasPolicy({ type: 'Asset', action: 'destroy' }) &&
            !asset.soldOn && !asset.removedAt && (
            <>
              <LinkSpace />
              <Pressable onPress={confirmRemove}>
                <Text>- Remove from Inventory</Text>
              </Pressable>
            </>
          )}

          {hasPolicy({ type: 'Asset', action: 'destroy' }) &&
            asset.canBeDestroyed && (
            <>
              <LinkSpace />
              <Pressable onPress={confirmDestroy}>
                <Text>- Delete Asset Completely</Text>
              </Pressable>
            </>
          )}

          {asset.removedAt && (
            <>
              <LinkSpace />
              <Pressable onPress={confirmReadd}>
                <Text>- Readd to Inventory</Text>
              </Pressable>
            </>
          )}

          <LinkSpace />
          <Pressable
            onPress={() => connectToSoarr({ variables: { id: asset.id }})}
          >
            <Text>Refresh SOARR data</Text>
          </Pressable>

          <EndLinksContainer>
            <TitleLogContainer id='title-log-container'>
              {getTitleLogInterface()}
            </TitleLogContainer>
            {asset?.soldOn &&
              <View style={{display: 'flex', flexDirection: 'row'}}>
                { ` | ` }
                <LinkSpace />
                <ReleaseContainer id='release-container'>
                  {getReleaseInterface()}
                </ReleaseContainer>
              </View>
            }
          </EndLinksContainer>
        </LinkContainer>
      </AssetSubNav>
      <MainContainer>
        <ContentContainer>
          <AssetsShowContainer>
            <View style={{flex: 1}}>
              {photoUrl && <Photo src={photoUrl} alt={asset?.stockNumber} />}
            </View>
            <View style={{flex: 5}}>
              <UpperRow>
                <Column>
                  <Text><b>Stock #: </b>{asset?.stockNumber}</Text>
                  <Text><b>VIN: </b>{asset?.vin}</Text>
                  <Text>
                    <b>{asset?.seller.clientNumberLabelFull}: </b>
                    {asset?.clientNumber}
                  </Text>
                  <Text><b>Category: </b>{asset?.category}</Text>
                  <Text><b>Sub-category: </b>{asset?.subCategory}</Text>
                  <Field>
                    <Label>Mechanical Conditions:</Label>
                    <Value>{asset?.mechanicalCondition}</Value>
                    {asset && (
                      <ResourceNotifications
                        resource={asset}
                        field="mechanicalCondition"
                      />
                    )}
                  </Field>
                  <Field>
                    <Label>Expected Yield Price:</Label>
                    <Value>{currency(asset?.expectedYieldPrice)}</Value>
                    {asset && (
                      <ResourceNotifications
                        resource={asset}
                        field="expectedYieldPrice"
                      />
                    )}
                  </Field>
                  <Field>
                    <Label>Reserve Price:</Label>
                    <Value>
                      {
                        currency(
                          asset?.activeSaleAsset?.reservePrice ||
                          asset?.reservePrice
                        )
                      }
                    </Value>
                  </Field>
                  {asset?.seller?.isEquiplinc && asset?.acquired &&
                    <Text>
                      <b>Acquired: </b>
                      {asset?.acquired}
                      <br />
                      <b>Acquired Date: </b>
                      {asset?.acquiredOn &&
                        moment(asset?.acquiredOn).format('MM-DD-YY')
                      }
                    </Text>
                  }
                  {asset?.uccExpiresOn ?
                    <Text>
                      <b>Eligible Sale Date: </b>
                      {moment(asset?.uccExpiresOn).format('MM-DD-YY')}
                    </Text> :
                    null
                  }
                </Column>
                <Column>
                  <Text>
                    <b>Odometer: </b>
                    {asset?.miles > 0 && numberWithDelimiter(asset?.miles)}
                  </Text>
                  <Text>
                    <b>Date Secured: </b>
                    {asset?.securedOn ?
                      moment(asset.securedOn).format('M/D/YY') : ''}
                  </Text>
                  <Text>
                    <b>List Price: </b>
                    {currency(asset?.listPrice)}
                  </Text>
                  <Text>
                    <b>Location: </b>
                    {formattedLocation(asset, { lineBreak: true })}
                  </Text>
                  {asset?.consignmentMethod &&
                    <Text>
                      <b>{`${asset?.consignmentMethod}: `}</b>
                      {formattedConsignmentLocation(asset, {lineBreak: true})}
                    </Text>
                  }
                  <Text>
                    <b>Drivable: </b>
                    {asset?.drivable ? 'Yes' : 'No'}
                  </Text>
                  <Text>
                    <b>Sell Fee: </b>
                    {sellFee}
                  </Text>
                </Column>
                <Column>
                  <Text><b>Engine Specifications</b></Text>
                  <Text>Manufacturer: {asset?.engineMfr}</Text>
                  <Text>Engine Type: {asset?.engineType}</Text>
                  <Text>Engine HP: {asset?.horsepower}</Text>
                </Column>
                <Column>
                  <Text><b>Drivetrain Specifications</b></Text>
                  <Text>Transmission: {asset?.transmission}</Text>
                  <Text>Axel: {asset?.axle}</Text>
                  <Text>Ratio: {asset?.ratio}</Text>
                  <Text>Wheelbase: {asset?.wheelBase}</Text>
                </Column>
                <Column>
                  <Text>Front Wheels: {asset?.wheelsFront}</Text>
                  <Text>Rear Wheels: {asset?.wheelsRear}</Text>
                  <Text>Sleeper: {asset?.sleeper}</Text>
                  <Text>Color: {asset?.color}</Text>
                </Column>
              </UpperRow>

              {!asset.showOnWeb && (
                <Text style={{ fontWeight: 600, color: 'red' }}>
                  Asset NOT Launched on Buyer Website
                </Text>
              )}
              <Text>
                <b>Inspection: </b>
                {asset?.inspectionUrl ?
                  <View>
                    <a
                      href={asset?.inspectionUrl}
                      target="_blank"
                      rel="nofollow"
                    >
                      {asset?.inspectionUrl}
                    </a>
                  </View> :
                  'None Entered'
                }
              </Text>
              <Text>
                <b>NIS Inspection: </b>
                {asset?.nisInspectionUrl ?
                  <View>
                    <a
                      href={asset?.nisInspectionUrl}
                      target="_blank"
                      rel="nofollow"
                    >
                      {asset?.nisInspectionUrl}
                    </a>
                  </View> :
                  'None Entered'
                }
              </Text>
              <Text>
                <b>Title Release Process: </b>
                {asset?.titleApplicableAsset}
              </Text>
              { (asset?.soldOn != null) &&
                <Text>
                  <b>Pre-Release URL: </b>
                  {asset?.preReleaseUrl}
                </Text>
              }
              <LowerRow>
                <View>
                  <Text>
                    {asset?.designation}
                  </Text>
                </View>
                <NotesContainer>
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Text><b>Notes:</b></Text>
                    <Pressable
                      onPress={() => setShowEditNotesModal(true)}
                    >
                      <Text>edit</Text>
                    </Pressable>
                  </View>
                  <Text>
                    {asset?.notes}
                  </Text>
                </NotesContainer>
              </LowerRow>
              <LowerRow>
                <SellerNotesContainer>
                  <Text><b>Seller Notes:</b></Text>
                  <View style={{marginLeft: '10px'}}>
                    {asset?.sellerNotes}
                  </View>
                </SellerNotesContainer>
              </LowerRow>
            </View>
          </AssetsShowContainer>
          <TabButtonContainer>
              <AssetTabButton
                onPress={() => setActiveTab('Fees')}
                active={'Fees' === activeTab}
              >
                <TabText active={'Fees' === activeTab}>Fees</TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('Expenses')}
                active={'Expenses' === activeTab}
              >
                <TabText active={'Expenses' === activeTab}>
                  Expenses
                </TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('Invoices')}
                active={'Invoices' === activeTab}
              >
                <TabText active={'Invoices' === activeTab}>
                  Invoices
                </TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('TitleLogs')}
                active={'TitleLogs' === activeTab}
              >
                <TabText active={'TitleLogs' === activeTab}>
                  Title Logs
                </TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('SaleHistory')}
                active={'SaleHistory' === activeTab}
              >
                <TabText active={'SaleHistory' === activeTab}>
                  Sale and Bid History
                </TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('Correspondence')}
                active={'Correspondence' === activeTab}
              >
                <TabText active={'Correspondence' === activeTab}>
                  Correspondence
                </TabText>
              </AssetTabButton>
              <AssetTabButton
                onPress={() => setActiveTab('Seller Notes/Documents')}
                active={'Seller Notes/Documents' === activeTab}
              >
                <TabText active={'Seller Notes/Documents' === activeTab}>
                  Seller Notes/Documents
                </TabText>
              </AssetTabButton>
            </TabButtonContainer>
          <TableContainer>
            {getActiveTabbedContent()}
          </TableContainer>
        </ContentContainer>
      </MainContainer>
      {showAddAssettoSaleModal &&
        <Modal
          setShowModal={setShowAddAssettoSaleModal}
          asset={asset}
          modalType={'Add Asset to Sale'}
        >
          <AddAssetToSale
            setShowModal={setShowAddAssettoSaleModal}
            saleAsset={showAddAssettoSaleModal?.sale && showAddAssettoSaleModal}
            assetId={asset?.id}
            refetch={refetch}
          />
        </Modal>
      }
      {showAddUsersToAssetModal &&
        <Modal
          setShowModal={setShowAddUsersToAssetModal}
          asset={asset}
          modalType={'Add Users to Asset'}
          style={{marginRight: 0}}
        >
          <AssignToUsers
            sellerId={sellerId}
            setShowModal={setShowAddUsersToAssetModal}
            assetId={asset?.id}
            fromShow={true}
            showSelectedUsers={asset?.assetUsers?.map(resource => resource.user.id)}
            showSelectedSellerUsers={asset?.assetSellerUsers?.map(
              resource => resource.sellerUser.id
            )}
          />
        </Modal>
      }
      {(showAddTitleLogModal || showEditTitleLogModal) &&
        <Modal
          setShowModal={showAddTitleLogModal ?
            setShowAddTitleLogModal :
            setShowEditTitleLogModal
          }
          modalType={`${showAddTitleLogModal ? 'Add' : 'Show' } Title Log`}
        >
          {showAddTitleLogModal ?
            <NewTitleLog
              setShowModal={setShowAddTitleLogModal}
              assetId={asset?.id}
              knownAsset={asset}
              refetch={refetch}
            /> :
            <EditTitleLog
              setShowModal={setShowEditTitleLogModal}
              assetId={asset?.id}
              knownAsset={asset}
              knownTitleLog={showEditTitleLogModal}
              assetMiles={asset?.miles}
            />
          }
        </Modal>
      }
      {showTitleLogHistory &&
        <Modal
          setShowModal={setShowTitleLogHistory}
          asset={asset}
          modalType={'Title Log History'}
          style={{marginRight: 0}}
        >
          <TitleLogHistory asset={asset} />
        </Modal>
      }
      {showEditNotesModal &&
        <Modal
          setShowModal={setShowEditNotesModal}
          asset={asset}
          modalType={'Edit Notes'}
          style={{marginRight: 0}}
        >
          <EditNotes
            asset={asset}
            setShowModal={setShowEditNotesModal}
            refetch={refetch}
          />
        </Modal>
      }
    </View>
  )

  function getTitleLogInterface() {
    let last_log = asset?.titleLogs[asset?.titleLogs.length - 1] || null;

    return (
      <TitleLogLinks>
        {last_log !== null &&
            <View>
              <Pressable
                // onPress={() => setShowEditTitleLogModal(true)}
                onPress={() => setShowTitleLogHistory(true)}
              >
                <View style={{display: 'flex', flexDirection: 'row'}}>
                  <TitleLogStatus>
                    <Text>Title Status: </Text>
                    <Text><b>{last_log.status}</b></Text>
                  </TitleLogStatus>
                  <FontAwesomeIcon
                    icon={faClockRotateLeft}
                    size="md"
                    title="View Bid History"
                    style={{marginLeft: '-15px', marginRight: '15px'}}
                  />
                </View>
              </Pressable>
              <LinkSpace />
            </View>
        }
        <Pressable
          onPress={() => {
            setShowAddTitleLogModal(true)
          }}
        >
          <Text>+ Add New Title Log</Text>
        </Pressable>
      </TitleLogLinks>
    )
  }

  function showTitleLogs() {
    const titleLogColumns = [
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'trackingNumber',
        label: 'Tracking Number',
        value: ({ entry, value }) => {
          if (value && entry.trackingShipper) {
            return `${value} - ${entry.trackingShipper}`;
          } else {
            return value
          }
        }
      },
      {
        key: 'notes',
        label: 'Notes',
        content: ({ entry, value }) => (
          <View>
            {'Release' === entry.status &&
              entry.asset.titleReleaseWarning && (
              <Text style={{color: 'red', fontWeight: 600}}>
                {entry.asset.titleReleaseWarning}
              </Text>
            )}
            <Text>{value}</Text>
          </View>
        )
      },
      {
        key: 'upload',
        label: 'File',
        // width: '20%',
        content: ({ entry }) => (
          <View>
            {getFileType(entry)}
          </View>
        )
      },
      {
        key: 'functions',
        label: 'Functions',
        // width: '15%',
        // minViewportWidth: 1000,
        content: ({ entry }) => {
          return (
            <View style={{display: 'inline-flex'}}>
              <Pressable
                onPress={() => {
                  setShowEditTitleLogModal(entry);
                  setClickedTitleLog(entry)
                }}
              >
                Edit
              </Pressable>
            </View>
          )
        }
      }
    ]
    return (
      <MainContainer>
        <ContentContainer>
          <PageTitle>Title Logs</PageTitle>
          <DataTable.Simple
            data={asset?.titleLogs}
            columns={titleLogColumns}
            htmlTable
          />
        </ContentContainer>
      </MainContainer>
    )
  }

  function createRelease() {
    if(window.confirm(`${asset?.releaseSentAt ? 'Resend' : 'Send'} Release?`)) {
      updateReleaseSent({
        variables: {
          id: parseInt(asset?.id),
          releaseSentAt: moment()._d
        }
      })
    }
  }

  function getReleaseInterface() {
    const releaseOption = asset?.seller?.releaseOption;
    if(asset?.releaseSentAt && releaseOption === 'Do not auto-generate') {
      return (
        <TitleLogLinks>
          <TitleLogStatus>
            <Text>
              <b>
                {`Release sent on ${moment(asset?.releaseSentAt).format('M/D/YY h:mm a')}`}
              </b>
            </Text>
          </TitleLogStatus>
          <Pressable
            onPress={() => createRelease()}
          >
            <Text>Resend</Text>
          </Pressable>
        </TitleLogLinks>
      )
    }else if(!asset?.releaseSentAt && releaseOption === 'Do not auto-generate') {
      return(
        <TitleLogLinks>
          <Pressable
            onPress={() => createRelease()}
          >
            <Text>Create Release</Text>
          </Pressable>
          <LinkSpace />
        </TitleLogLinks>
      )
    }else if(asset.releaseSentAt) {
      <TitleLogLinks>
        <TitleLogStatus>
          <Text>
            <b>
              {`Release sent on ${moment(asset?.releaseSentAt).format('M/D/YY h:mm a')}`}
            </b>
          </Text>
        </TitleLogStatus>
      </TitleLogLinks>
    }
  }

  function getActiveTabbedContent() {
    if(activeTab === 'TitleLogs') {
      return showTitleLogs()
      // return <TitleLogs assetId={asset?.id} asset={asset} />
    }else if(activeTab === 'Expenses') {
      return <Expenses asset={asset} />;
    }else if(activeTab === 'Invoices') {
      return <Invoices />
    }else if(activeTab === 'Correspondence') {
      return <Correspondence resourceType='Asset' resourceId={asset?.id} />
    }else if(activeTab === 'SaleHistory') {
      return <SaleHistory asset={asset} refetchAsset={refetch} />
    }else if('Seller Notes/Documents' === activeTab) {
      return (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            margin: '20px'
          }}
        >
          <View style={{flexDirection: 'column', flexBasis: '100%', flex: 1}}>
            <b>Seller Asset Notes:</b>
            <View
              style={{marginLeft: '20px'}}
            >
              {asset.sellerNotes}
            </View>
          </View>
          <View style={{flexDirection: 'column', flexBasis: '100%', flex: 1}}>
            <b>Documents:</b>
            {asset.sellerDocuments?.map(document => {
              return (
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: '20px',
                    marginBottom: '10px'
                  }}
                >
                  <Link to={document.url} target='_blank'>
                    <Text>
                      {document.filename}
                    </Text>
                  </Link>
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginLeft: '20px',
                      marginTop: '2px'
                    }}
                  >
                    <Text style={{marginRight: '5px'}}><b>Notes:</b></Text>
                    {
                      asset.sellerDocumentNotes.map(note => {
                        if(note.attachmentId === document.id) {
                          return <Text>{note.body}</Text>
                        }
                      })
                    }
                  </View>
                </View>
              )
            })}
            {!asset?.sellerDocuments &&
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '20px',
                  marginTop: '2px'
                }}
              >
                <Text>None Added</Text>
              </View>
            }
          </View>
        </View>
      )
    }else {
      return <Fees asset={asset} refetchAsset={refetch} />
    }
  }

  function getFileType(entry) {

    if(entry.upload){
      return (
        <Link to={entry.upload.url} target='_blank'>
          <Text>
            {entry.upload.filename}
          </Text>
        </Link>
      )
    }else if(entry.linkedAttachment) {
      return (
        <Link to={entry.linkedAttachment?.url} target='_blank'>
          <Text>
            {`${entry.linkedAttachment?.name} (linked)`}
          </Text>
        </Link>
      )
    }
  }
}

export default Asset;
